import { isLang, type Lang } from '../i18n'

/** English lives at the root, the other languages under /me/ and /ru/ (see scripts/prerender.mjs). */
export function homePath(lang: Lang): string {
  return lang === 'en' ? '/' : `/${lang}/`
}

/** Case-study page: /work/<id>/, /me/work/<id>/, /ru/work/<id>/. */
export function casePath(lang: Lang, id: string): string {
  return `${homePath(lang)}work/${id}/`
}

export interface Route {
  /** Language named by the path prefix, or null for the unprefixed (English) paths. */
  lang: Lang | null
  caseId: string | null
}

export function parseRoute(pathname: string): Route {
  const parts = pathname.split('/').filter(Boolean)
  const lang = isLang(parts[0]) ? parts.shift() : null
  const caseId = parts[0] === 'work' && parts[1] ? decodeURIComponent(parts[1]) : null
  return { lang: lang as Lang | null, caseId }
}
